import Marquee from "react-fast-marquee";

const words = ["TENS", "EMS", "INTERFERENTIAL", "MICROCURRENT", "RECOVERY", "DRUG-FREE", "WEARABLE", "CLINIC-GRADE"];

export function EditorialMarquee() {
    return (
        <section data-testid="editorial-marquee" className="bg-secondary border-y border-border py-8 overflow-hidden">
            <Marquee speed={28} gradient={false}>
                {words.map((w, i) => (
                    <span key={i} className="flex items-center">
                        <span className="font-mono-tech uppercase text-2xl sm:text-4xl font-medium text-obsidian/80 tracking-tight mx-16">
                            {w}
                        </span>
                        <span className="w-2 h-2 rounded-full bg-cyan" />
                    </span>
                ))}
            </Marquee>
        </section>
    );
}
